import { render, staticRenderFns } from "./RubricPurInvoiceList.vue?vue&type=template&id=454dcd6a&scoped=true&"
import script from "./RubricPurInvoiceList.vue?vue&type=script&lang=js&"
export * from "./RubricPurInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./RubricPurInvoiceList.vue?vue&type=style&index=0&id=454dcd6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454dcd6a",
  null
  
)

export default component.exports